module.exports = "/images/840c3e0af2f4ec3977d9c7fdee080e31.svg";